var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatBold24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.225 6.79C10.195 6.12 10.875 5.02 10.875 4C10.875 1.74 9.125 0 6.875 0H0.625V14H7.665C9.755 14 11.375 12.3 11.375 10.21C11.375 8.69 10.515 7.39 9.225 6.79ZM3.625 2.5H6.625C7.455 2.5 8.125 3.17 8.125 4C8.125 4.83 7.455 5.5 6.625 5.5H3.625V2.5ZM3.625 11.5H7.125C7.955 11.5 8.625 10.83 8.625 10C8.625 9.17 7.955 8.5 7.125 8.5H3.625V11.5Z",
    fill: "#526069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatBold24Px);
export default __webpack_public_path__ + "static/media/format_bold_24px.7c0dc2c7c172aee0b83a2150e49adb0d.svg";
export { ForwardRef as ReactComponent };